import React, { useEffect, useState } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, Switch, DatePicker } from "antd";
import ModalCommon from "../../components/Modal";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/** Luôn hiển thị/parse theo giờ VN (+7), tránh lệch khi máy admin ở múi giờ khác (ví dụ UTC+5:30). */
const SCHEDULE_TZ = "Asia/Bangkok";

const TEXT = {
  onOffGame: "Bật/Tắt game",
  eventStartTime: "Thời gian bắt đầu sự kiện",
  eventEndTime: "Thời gian kết thúc sự kiện",
};

const scheduleToPicker = (iso) => {
  if (!iso) return null;
  return dayjs(iso).tz(SCHEDULE_TZ);
};

const OnOffGame = () => {
  const [configGame, setConfigGame] = useState();
  const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
  const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

  const [pickerStart, setPickerStart] = useState(null);
  const [pickerEnd, setPickerEnd] = useState(null);
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [isShowGame, setIsShowGame] = useState();

  useEffect(() => {
    getDataConfig();
  }, []);

  const getDataConfig = async () => {
    try {
      const res = await API.get(`${CONFIG}`);
      const data = res.data?.data || res.data;
      const isGameEnabled = data.schedule?.isGameEnabled;
      const eventStart = data.schedule?.eventStart;
      const eventEnd = data.schedule?.eventEnd;

      setConfigGame({
        isGameEnabled,
        eventStart,
        eventEnd,
      });

      setPickerStart(scheduleToPicker(eventStart));
      setPickerEnd(scheduleToPicker(eventEnd));
      setDateFrom(undefined);
      setDateTo(undefined);

      if (isGameEnabled !== undefined) {
        setIsShowGame((prev) => (prev === undefined ? isGameEnabled : prev));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const formatRequest = (dateFm) => {
    return dayjs.tz(dateFm, "YYYY-MM-DD HH:mm:ss", SCHEDULE_TZ).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
  };

  const handleUpdateConfig = async () => {
    try {
      setIsShowModalConfirm(false);

      const body = {
        config: {
          schedule: {
            isGameEnabled: isShowGame,
            eventStart: dateFrom ? formatRequest(dateFrom) : configGame?.eventStart,
            eventEnd: dateTo ? formatRequest(dateTo) : configGame?.eventEnd,
          },
        },
      };

      await API.patch(`${UPDATE_CONFIG}`, body);
      setIsShowModalSuccess(true);
      getDataConfig();
    } catch (err) {
      console.log(err);
    }
  };

  const handleShowModal = () => {
    setIsShowModalConfirm(true);
  };

  const onStartPickerChange = (d) => {
    setPickerStart(d);
    if (d) {
      setDateFrom(d.tz(SCHEDULE_TZ).format("YYYY-MM-DD HH:mm:ss"));
    } else {
      setDateFrom(undefined);
    }
  };

  const onEndPickerChange = (d) => {
    setPickerEnd(d);
    if (d) {
      setDateTo(d.tz(SCHEDULE_TZ).format("YYYY-MM-DD HH:mm:ss"));
    } else {
      setDateTo(undefined);
    }
  };

  const checkFlagShow = () => {
    return configGame.isGameEnabled;
  };

  const handleChangeSwitch = (e) => {
    setIsShowGame(e);
  };

  return (
    <div className="col-12">
      <div className="col-12">
        <div className="flex w-full">
          <div className="flex flex-col w-full items-center justify-center">
            <div className="col-10 mt-2 flex flex-col items-center justify-center">
              <div className="flex w-full items-center">
                <div className="flex w-[20%] justify-end mr-10">{TEXT.onOffGame}:</div>
                {configGame?.eventStart && (
                  <div className="w-[60%]">
                    <Switch
                      checkedChildren="On"
                      unCheckedChildren="Off"
                      checked={isShowGame !== undefined ? isShowGame : checkFlagShow()}
                      style={{ width: 60, marginTop: "5px" }}
                      onChange={(e) => handleChangeSwitch(e)}
                    />
                  </div>
                )}
              </div>
              {configGame?.eventStart && (
                <div className="flex w-full items-center mt-4">
                  <div className="flex w-[20%] justify-end mr-10">{TEXT.eventStartTime}:</div>
                  <div className="w-[60%]">
                    <DatePicker
                      placeholder=""
                      value={pickerStart}
                      onChange={onStartPickerChange}
                      format="DD-MM-YYYY HH:mm:ss"
                      style={{ width: "100%" }}
                      disabledTime={(d) => !d || (!!pickerEnd && d.isAfter(pickerEnd))}
                      showTime
                    />
                  </div>
                </div>
              )}
              {configGame?.eventEnd && (
                <div className="flex w-full items-center mt-4">
                  <div className="flex w-[20%] justify-end mr-10">{TEXT.eventEndTime}:</div>
                  <div className="w-[60%]">
                    <DatePicker
                      placeholder=""
                      value={pickerEnd}
                      onChange={onEndPickerChange}
                      format="DD-MM-YYYY HH:mm:ss"
                      style={{ width: "100%" }}
                      disabledTime={(d) => !d || (!!pickerStart && d.isBefore(pickerStart))}
                      showTime
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="col-10 mt-5 flex items-center justify-center">
              <Button type="primary" onClick={handleShowModal}>
                Cập nhật
              </Button>
            </div>
          </div>
        </div>
      </div>
      {isShowModalConfirm && (
        <ModalCommon
          isShow={isShowModalConfirm}
          message={TEXT_DEF.text0062}
          txtBtnAcc={TEXT_DEF.text0008}
          textBtnClose={TEXT_DEF.text0023}
          actionNext={handleUpdateConfig}
          close={() => setIsShowModalConfirm(false)}
        />
      )}
      {isShowModalSuccess && (
        <ModalCommon
          isShow={isShowModalSuccess}
          message={TEXT_DEF.text0063}
          txtBtnAcc={TEXT_DEF.text0007}
          actionNext={() => {
            setIsShowModalSuccess(false);
          }}
          close={() => {
            setIsShowModalSuccess(false);
          }}
        />
      )}
    </div>
  );
};

export default OnOffGame;
